/**
 * @generated SignedSource<<e4cb35735626c431e1a93588f936dc45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutineOverviewUpdateInput = {
  setTeamIds?: ReadonlyArray<string> | null;
};
export type WSChecklistOverviewMutation$variables = {
  storecastId: string;
  update: WidgetRoutineOverviewUpdateInput;
  widgetId: string;
};
export type WSChecklistOverviewMutation$data = {
  readonly dashboard: {
    readonly updateWidgetRoutineOverview: {
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewDataComponent_widgetRoutineOverview">;
    };
  };
};
export type WSChecklistOverviewMutation = {
  response: WSChecklistOverviewMutation$data;
  variables: WSChecklistOverviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "update"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "dashboardId",
    "variableName": "storecastId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  },
  {
    "kind": "Variable",
    "name": "update",
    "variableName": "update"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSChecklistOverviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "WidgetRoutineOverview",
            "kind": "LinkedField",
            "name": "updateWidgetRoutineOverview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetRoutineOverviewDataComponent_widgetRoutineOverview"
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSChecklistOverviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "WidgetRoutineOverview",
            "kind": "LinkedField",
            "name": "updateWidgetRoutineOverview",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routines",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "ownerTeam",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineOccasion",
                    "kind": "LinkedField",
                    "name": "inProgressOccasion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expireAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "calculateNoTasks",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "calculateNotCompletedStarted",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sequenceNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deadlineAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f5088775aa1059d64d0fb4d93c8ba7c3",
    "id": null,
    "metadata": {},
    "name": "WSChecklistOverviewMutation",
    "operationKind": "mutation",
    "text": "mutation WSChecklistOverviewMutation(\n  $storecastId: ID!\n  $widgetId: ID!\n  $update: WidgetRoutineOverviewUpdateInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    updateWidgetRoutineOverview(id: $widgetId, update: $update) {\n      id\n      ...WidgetRoutineOverviewDataComponent_widgetRoutineOverview\n      teams {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment WidgetRoutineOverviewDataComponent_widgetRoutineOverview on WidgetRoutineOverview {\n  id\n  title\n  routines {\n    id\n    ...WidgetRoutineOverviewListItem_routine\n    inProgressOccasion {\n      expireAt\n      startAt\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...WidgetRoutineOverviewListItem_routineOccasion\n      id\n    }\n  }\n}\n\nfragment WidgetRoutineOverviewListItemExpireText_routineOccasion on RoutineOccasion {\n  startAt\n  expireAt\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n}\n\nfragment WidgetRoutineOverviewListItem_routine on Routine {\n  id\n  title\n  ownerTeam {\n    id\n    name\n  }\n}\n\nfragment WidgetRoutineOverviewListItem_routineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  sequenceNumber\n  ...WidgetRoutineOverviewListItemExpireText_routineOccasion\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n}\n"
  }
};
})();

(node as any).hash = "84bd2e4f5a414b294a3ea8c77768c5bc";

export default node;
